import { Footer as SimpleFooter } from "@/components/ui/footer";

const Footer = () => {
  return (
    <div className="border-t border-white/5 bg-background">
      <div className="container mx-auto">
        <SimpleFooter
          logo={
            <img
              src="/lovable-uploads/302515c5-7391-4a01-9649-064e9325fd8f.png"
              alt="Klexu Logo"
              width="163"
              height="40"
              className="h-9 w-auto"
            />
          }
          brandName={`
`}
          socialLinks={[]}
          mainLinks={[
            { href: "/about", label: "About Us" },
            { href: "/consultation", label: "Contact" },
          ]}
          legalLinks={[
            { href: "/privacy-policy", label: "Privacy Policy" },
            { href: "/terms", label: "Terms of Service" },
            { href: "/cookie-policy", label: "Cookie Policy" },
          ]}
          copyright={{
            text: `© ${new Date().getFullYear()} Klexu`,
            license: "All rights reserved",
          }}
        />
      </div>
    </div>
  );
};

export default Footer;
